module.exports = __webpack_public_path__ + "static/media/create_funnel_sample.a034b6f3.png";